<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="section">
        <strong>Dashboard</strong>
      </div>
    </div>

    <div class="ui divider"></div>

    <div class="ui grid">

      <div class="eight wide computer sixteen wide tablet sixteen wide mobile column">
        <open-quotations-chart />
      </div>

      <div class="eight wide computer sixteen wide tablet sixteen wide mobile column">
        <consolidated-quotations-chart />
      </div>

      <div class="sixteen wide column">
        <quotations-waiting-confirmation-chart />
      </div>

    </div>

  </div>

</template>

<script>

  import { ConsolidatedQuotationsChart, OpenQuotationsChart, QuotationsWaitingConfirmationChart } from "./charts"

  export default {

    components: {
      ConsolidatedQuotationsChart,
      OpenQuotationsChart,
      QuotationsWaitingConfirmationChart,
    },

    beforeCreate() {

      if (this.$isCustomerOrProspect())
        this.$router.push("products/search")
    },
  }

</script>
